// extracted by mini-css-extract-plugin
export default {"success-error-page":"SuccessErrorPage_success-error-page__R7whe"};